<swiper [zoom]="true" (zoomChange)="onZoomChange($event)">
    <ng-template swiperSlide>
        <div class="swiper-zoom-container">
            <img [src]="image.props.default | cdnFileUploadedResolver" alt="Default image full screen">
        </div>
    </ng-template>
</swiper>

